import { LiveDataSet } from "../../API/LiveData/LiveDataSet";
import { IUnitsConversionSet } from "../../Converters/UnitsConverter/IUnitsConverter";
import { ILiveDataListener } from "../../ILiveDataListener";
import { InfluxDataWrapper } from "../../InfluxDb/InfluxDataWrapper";
import { getHistoricData } from "../../InfluxDb/InfluxDb";
import { MainSite } from "../../MainSite";
import { ISiteObservationsPage } from "./ISiteObservationsPage";

export interface MiniChartDataSet {
    stationId: string;
    sensorId: string;
    parameterId: string;
    // parameterDefs?: ParameterDefinition | null;
    units: string;
    plotLine: boolean;
    variant?: string;
    yAxisIndex: number;
}

export class MiniChart implements ILiveDataListener {
    private $wrapper: JQuery;
    private $toolbar: JQuery;
    private $loading: JQuery;
    private $chartContainer: JQuery;
    private $messages: JQuery;

    private timeZoneString: string;
    private chart: __Highcharts.ChartObject;
    private errors: string[] = []; //: TODO: if any, display!!
    private rangeDays: number = 3;
    private possibleRangeDays: number[] = [3, 5, 7];

    /**
     * Create an instance of a MiniChart, initially intended for use within SiteObservation pages
     * @param mainSite The instance of the mainSite
     * @param page The instance of the parent page
     * @param title A title, shown in loading messages or errors/warnings.
     * @param dataSets The sets of data to retrieve from latest LiveDataSet and also getHistoricData().
     * @param $container The target container
     * @param top
     * @param left
     * @param height
     * @param width
     */
    constructor(
        private mainSite: MainSite,
        private page: ISiteObservationsPage,
        private title: string,
        private $container: JQuery,
        private dataSets: MiniChartDataSet[],
        private yAxisOptions: __Highcharts.AxisOptions[]
    ) {
        this.timeZoneString = this.mainSite.getTimeZoneString();

        this.$container.empty();

        this.$wrapper = $('<div class="minichart-wrapper" style="position: relative; width: 100%; height: 100%; z-index: 100; display: flex; flex-direction: column;">').appendTo(this.$container);
        //this.$wrapper.css({ border: '1px dotted blue' });
        this.$wrapper.data('minichart', this);

        this.$toolbar = $(`<div class="minichart-toolbar" style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 4px;">`).appendTo(this.$wrapper);
        this.$loading = $(`<div class="text-muted"><i class="fa fa-fw fa-refresh fa-spin"></i> <em>${this.title} loading...</em></div>`).appendTo($('<div>').appendTo(this.$toolbar)); //: NB: wrapped in div to ensure flex works.

        let $btnBar: JQuery = $(`<div class="btn-group btn-group-sm">`).appendTo(this.$toolbar);
        this.possibleRangeDays.forEach(days => {
            let $btn: JQuery = $(`<button type="button" class="btn btn-default minichart-setdays" data-days="${days}">${days} days</button>`).appendTo($btnBar);
            if (days == this.rangeDays) {
                $btn.addClass('active');
            }
            $btn.on('click', (e) => {
                e.preventDefault();
                this.setRangeDays(days);

                //: syn any other visible chart:
                let $others: JQuery = $(`.minichart-wrapper:visible`).not($btn.closest('.minichart-wrapper'));
                if ($others.length > 0) {
                    $others.each((i, el) => {
                        let _mc: MiniChart = $(el).data('minichart');
                        _mc.setRangeDays(days);
                    });
                }
            });
        });

        this.$chartContainer = $(`<div class="minichart-chart-container" style="flex-grow: 1;">`).appendTo(this.$wrapper); //  background-color: rgba(0,0,255,0.05);
        this.$chartContainer.highcharts(<__Highcharts.Options>{
            chart: {
                type: 'line',
                backgroundColor: '#FFF',
                marginTop: 30,
                zoomType: 'x'
            },
            exporting: {
                enabled: true
            },
            title: {
                text: '', // this.title,
                align: 'left',
                
            },
            xAxis: {
                type: 'datetime',
                ordinal: false,
                lineWidth: 0,
                lineColor: '#666'
            },
            yAxis: this.yAxisOptions,
            legend: {
                enabled: true,
            },
            plotOptions: {
                series: {
                    animation: false,
                    events: {
                        legendItemClick: function () {
                            return false;
                        }
                    },
                    showInNavigator: true
                },
                line: {
                    dataGrouping: {
                        approximation: "high"
                    }
                }
            },
            rangeSelector: {
                enabled: false,
                selected: 1
            },
            scrollbar: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            tooltip: {
                xDateFormat: '%Y-%m-%d %H:%M:%S ' + this.timeZoneString,
                valueDecimals: 1
            }
        });

        this.chart = this.$chartContainer.highcharts();
        this.loadingShow('Awaiting data...');

        this.updateChart(MainSite.instance.liveDataManager.latestData);
    }

    public setRangeDays(days: number): void {
        if (this.possibleRangeDays.indexOf(days) < 0) {
            return;
        }

        this.rangeDays = days;
        this.$toolbar.find('.btn.minichart-setdays.active').removeClass('active');
        this.$toolbar.find(`.btn.minichart-setdays[data-days="${days}"]`).addClass('active');
        this.updateChart(MainSite.instance.liveDataManager.latestData);
    }


    public liveDataChanged(latestData: LiveDataSet): void {
        this.updateChart(latestData);
    }

    private loadingShow(message: string = 'Getting data...'): void {
        this.chart.showLoading(message);
        this.$loading.show();
    }

    private loadingHide(): void {
        this.chart.hideLoading();
        this.$loading.hide();
    }

    private replaceChartSeries(seriesOptions: { [sensorId: string]: __Highcharts.SeriesOptions[] }) {
        // console.info(`MiniChart.replaceChartSeries..`, { seriesOptions: seriesOptions, chartSeries: $.extend(true, {}, this.chart.series) }); // , chartSeries: $.extend(true, {}, this.chart.series)
        // this.chart.hideLoading();
        if (this.chart.series.length < 1) {
            for (var sensorId in seriesOptions) {
                seriesOptions[sensorId].forEach((series) => {
                    this.chart.addSeries(series);
                });
            }
        } else {
            for (var sensorId in seriesOptions) {
                seriesOptions[sensorId].forEach((series) => {
                    var cs: __Highcharts.SeriesObject = <__Highcharts.SeriesObject>this.chart.get(series.id);
                    cs.setData(<any>series.data);
                });
            }
        }

        this.loadingHide();
        this.chart.reflow();
    }

    private updateChart(latestData: LiveDataSet): void {
        if (!latestData) {
            // console.info(`MiniChart.updateChart... IGNORING AS NO LATEST DATA. `, { latestData: latestData });
            return;
        }

        this.loadingShow();
        this.errors = [];

        let seriesOptions: { [sensorId: string]: __Highcharts.SeriesOptions[] } = {};
        let toMoment = moment.utc();
        let fromMoment = moment.utc().subtract(this.rangeDays, 'd');
        let anyData = false;

        /*for (let i = 0; i <= this.dataSets.length - 1; i++) {
            let ds: MiniChartDataSet = this.dataSets[i];
            console.info('debug', { i: i, ds: ds });
        }*/

        //: a bit ugly, but using an interval to ensure we have received data..
        let countReceivedDataResponses = 0;
        let countReceivedDataResponsesWithData = 0;

        let interval: number = setInterval(() => {
            if (countReceivedDataResponses == this.dataSets.length) {
                clearInterval(interval);
                interval = null;

                this.replaceChartSeries(seriesOptions);
                if (countReceivedDataResponsesWithData == 0) {
                    this.chart.showLoading('Data not available');
                }
            }
        }, 250);


        for (let i = 0; i <= this.dataSets.length - 1; i++) {
            let ds: MiniChartDataSet = this.dataSets[i];
            let _label: string = `${ds.sensorId}.${ds.parameterId}` + (ds.variant ? `.${ds.variant}` : '');

            // getHistoricData('P', 'GOM_Vito', 'AWOS', 'WindSpeed_kts', null, moment.utc().subtract(3, 'd').valueOf(), moment.utc().valueOf(), () => { }, 0)
            // getHistoricData('P', 'GOM_Vito', 'AWOS', 'WindDirection_deg', null, moment.utc().subtract(3, 'd').valueOf(), moment.utc().valueOf(), () => { }, 0)

            // console.info(`MiniChart.updateChart... GETTING DATA: `, {  ds: ds, i: i, label: _label, range: [fromMoment.valueOf(), toMoment.valueOf()] });
            getHistoricData(
                'P',
                ds.stationId,
                ds.sensorId,
                ds.parameterId,
                ds.variant ?? null,
                fromMoment.valueOf(),
                toMoment.valueOf(),
                (err: any, data: InfluxDataWrapper) => {
                    countReceivedDataResponses++; //: here so even if response error..

                    // console.info(`MiniChart.updateChart... DATA RESPONSE: `, { ds: ds, i: i, label: _label, range: [fromMoment.valueOf(), toMoment.valueOf()], err: err, data: data });
                    if (err) {
                        // alert('Error getting data: ' + err);
                        this.errors.push(`Error getting data for "${_label}"!`);
                        console.error(`MiniChart.updateChart - Error getting data for "${_label}"!`, { err: err, i: i, ds: ds, range: [fromMoment.valueOf(), toMoment.valueOf()] });
                        return;
                    }

                    anyData = anyData || data.Data !== null;

                    if (Array.isArray(data.Data) && data.Data.length > 0) {
                        countReceivedDataResponsesWithData++;
                    }

                    let unitsConversionSet: IUnitsConversionSet | null = MainSite.getUnitConverter().getConversionSet(ds.units, ds.parameterId);
                    if (unitsConversionSet) {
                        data.Data = data.Data.map(x => {
                            if (Array.isArray(x) && x.length == 2) {
                                return [x[0], unitsConversionSet.convertValue(x[1])];
                            }

                            return x;
                        });

                        if (ds.units !== unitsConversionSet.convertedUnits) {
                            _label += ` (${unitsConversionSet.convertedUnits})`;
                        }
                    }

                    if (data.Data !== null) {
                        data.Data.unshift([fromMoment.valueOf(), null]);
                        data.Data.push([toMoment.valueOf(), null]);
                    }

                    seriesOptions[ds.sensorId] = seriesOptions[ds.sensorId] || [];

                    let _seriesOptions: __Highcharts.SeriesOptions = {
                        id: ds.parameterId,
                        name: _label,
                        data: data.Data,
                        yAxis: ds.yAxisIndex,
                    };

                    if (ds.plotLine) {
                        _seriesOptions.marker = {
                            enabled: false
                        };
                        _seriesOptions.lineWidth = 1;
                    } else {
                        _seriesOptions.marker = {
                            enabled: true,
                            radius: 2
                        };
                        _seriesOptions.lineWidth = 0;
                    }

                    seriesOptions[ds.sensorId].push(_seriesOptions);
                }, 0);
        }
    }
}